
import { Component, Vue } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
import AppBarEnd from './components/AppBarEnd.vue';
import AppBar from '@/ui-components/AppBar/AppBar.vue';
import AppBarStart from '@/layouts/components/AppBarStart.vue';
import SideNav from '@/layouts/components/SideNav.vue';
import namespaces from '@/store/namespaces';
import { UserRouteNames } from '@/types/users';
import { Getter } from 'vuex-class';
import { initializeLanguageAndDirection } from "@/utils/locale";

@Component({
  name: 'StoreOwnerLayout',
  components: {
    SideNav,
    AppBarStart,
    AppBar,
    SearchBar,
    AppBarEnd,
  },
})
export default class StoreOwnerLayout extends Vue {
  @Getter('isAuthenticated', { namespace: namespaces.AuthModule })
  public isAuthenticated!: boolean;

  @Getter('userRouteNames', { namespace: namespaces.AuthModule })
  public userRouteNames!: UserRouteNames;

  public get dashboardRoute() {
    return this.userRouteNames.DASHBOARD;
  }

  created() {
    initializeLanguageAndDirection(this.$route);
  }
}
